import {ICategoriesWebServiceClient, MultilingualLibelleDto} from "@resources/resources";
import {Injectable} from "@angular/core";
import {Resolve} from "@angular/router";

@Injectable()
export class ReferentielCategoriesResolver implements Resolve<MultilingualLibelleDto[]> {

  constructor(private categoriesWebServiceClient: ICategoriesWebServiceClient) {
  }

  resolve() {
    return this.categoriesWebServiceClient.categoriesReferentiel();
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-commande-materiel/digicerba-commande-materiel-web/src/angular/cerba/src/app/pages/cerba/pages/administration/categories/enregistrement/admin.categories.resolver.ts